// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import './ErrorPage.css'

// Function based component rendering a simple error page
// This page is displayed when a user visits an invalid resource
function ErrorPage() {
  return <h1 className="med-error-page">Page not found</h1>
}

export default ErrorPage
